@if (data?.loading) {
	<div class="snack-spinner-container">
		<mat-spinner diameter="30" class="white-spinner"></mat-spinner>
		<span class="{{ data?.status }}">{{ data?.message }}</span>
	</div>
}
